export const API_VERSION = {
  V1: 'V1',
  V2: 'V2'
}

export const API_PATH_PREFIX_BY_API_VERSION = {
  [API_VERSION.V1]: 'api',
  [API_VERSION.V2]: 'v2'
}
